var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pie-chart'),_c('input',{ref:"fileInput",attrs:{"type":"file"}}),_c('button',{attrs:{"title":"Upload File"},on:{"click":_vm.uploadFile}},[_vm._v("Upload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }